import { render, staticRenderFns } from "./UiForm.vue?vue&type=template&id=e145c850&"
import script from "./UiForm.vue?vue&type=script&lang=js&"
export * from "./UiForm.vue?vue&type=script&lang=js&"
import style0 from "./UiForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports